import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Button } from '@smooth-ui/core-sc'
import { Route, Link } from 'react-router-dom'
import { Bars } from 'styled-icons/fa-solid/Bars'

import Logo from './Logo'

const Container = styled(Box)`
  background: ${p => p.theme.colors.gray1};
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
  padding: 0 1rem;
  height: 4rem;
  display: flex;
  align-items: center;
  width: 100%;
`
const LogoBox = styled(Box)`
  color: ${p => p.theme.colors.primary};
`
const NavButton = styled(Box)`
  color: ${p => (p.active ? p.theme.colors.primary : p.theme.colors.text)};
  padding: 0.5rem;
  display: inline-block;
  font-weight: bold;
  font-size: 1rem;
  font-style: italic;
  text-transform: uppercase;
`

const NavLink = ({ label, to, activeOnlyWhenExact }) => (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={({ match }) => (
      <NavButton as={Link} to={to} active={match}>
        {label}
      </NavButton>
    )}
  />
)

const Header = ({ menu, sidebarVisible, toggleSidebar }) => {
  return (
    <Container as="header">
      <Box
        alignItems="center"
        display="flex"
        justifyContent="space-between"
        flex="1"
      >
        <LogoBox>
          <Logo />
        </LogoBox>
        <Box>
          <Box display={{ xs: 'none', md: 'flex' }}>
            {menu &&
              menu.map((item, i) => {
                return <NavLink key={i} {...item} />
              })}
          </Box>
          <Button
            onClick={toggleSidebar}
            variant="primary"
            display={{ xs: 'flex', md: 'none' }}
          >
            <Box alignItems="center" display="flex">
              <Bars size="20" />
            </Box>
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

Header.propTypes = {
  homeLink: PropTypes.string
}

export default Header
